import dayjs from 'dayjs';

export const DATE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'weekToD\u200c\u200bate', label: 'Week to Date' },
  { value: 'last7Days', label: 'Last 7 Days' },
  { value: 'last14Days', label: 'Last 14 Days' },
  { value: 'last21Days', label: 'Last 21 Days' },
  { value: 'last28Days', label: 'Last 28 Days' },
  { value: 'last30Days', label: 'Last 30 Days' },
  { value: 'monthToD\u200c\u200bate', label: 'Month to Date' },
  { value: 'last60Days', label: 'Last 60 Days' },
  { value: 'customRange', label: 'Custom Range' },
];

export const DEFAULT_DATE_RANGE = 'today';
export const DEFAULT_TOP10_DATE_RANGE = 'last30Days';

// `now` defaults to the browser's clock, which is every existing caller's
// behavior; a caller that has re-read "now" in a particular store's zone
// (see use-finance-period.js's resolveFinanceRange) passes that instead, so
// a preset like 'today' is cut on the store's calendar day, not the
// reader's.
export const resolveDateRange = (selected, now = dayjs()) => {
  let enddate = now;
  let startdate;

  switch (selected) {
    case 'today':
      startdate = enddate.startOf('day');
      break;
    case 'yesterday':
      startdate = enddate.subtract(1, 'day').startOf('day');
      enddate = enddate.subtract(1, 'day').endOf('day');
      break;
    case 'weekToD\u200c\u200bate':
      startdate = enddate.startOf('week');
      break;
    case 'last7Days':
      startdate = enddate.subtract(7, 'day').startOf('day');
      break;
    case 'last14Days':
      startdate = enddate.subtract(14, 'day').startOf('day');
      break;
    case 'last21Days':
      startdate = enddate.subtract(21, 'day').startOf('day');
      break;
    case 'last28Days':
      startdate = enddate.subtract(28, 'day').startOf('day');
      break;
    case 'last30Days':
      startdate = enddate.subtract(30, 'day').startOf('day');
      break;
    case 'monthToD\u200c\u200bate':
      startdate = enddate.startOf('month');
      break;
    case 'last60Days':
      startdate = enddate.subtract(60, 'day').startOf('day');
      break;
    default:
      return null;
  }

  return { startdate, enddate };
};
